import Swiper from 'swiper';
import { Navigation, HashNavigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';

import { Fancybox } from "@fancyapps/ui/dist/fancybox/";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
// import {scrollToggleFixed} from "../../utils/scrollFixedNav";
// require("../../bootstrap");
require('../../sitio');

document.addEventListener('DOMContentLoaded', function ()
{

    Fancybox.bind("[data-fancybox]", {
        Toolbar: {
            display: {
                left: ["infobar"],
                middle: [],
                right: ["close"],
            },
        },
    });

    const swiperGalleryInterior = new Swiper('.swiper-gallery-interior', {
        loop: true,
        modules: [Navigation],
        navigation: {
            nextEl: ".swiper-next-gallery-interior",
            prevEl: ".swiper-prev-gallery-interior",
        },
        breakpoints: {
            320: {
                slidesPerView: 1,
            }
        }
    });

    const swiperGalleryExterior = new Swiper('.swiper-gallery-exterior', {
        loop: true,
        modules: [Navigation],
        navigation: {
            nextEl: ".swiper-next-gallery-exterior",
            prevEl: ".swiper-prev-gallery-exterior",
        },
        breakpoints: {
            320: {
                slidesPerView: 1,
            }
        }
    });

    new InitTabs({
        containerId: 'models-tabs',
        contentContainerSelector: '#models-tabs-content'
    });

    const promo = document.querySelector('#promotion-quotes');

    if (promo) {
        const inner = promo.querySelector('.promotion');
        const btnClose = promo.querySelector('.btn-close');

        let cycleInterval;
        let hideTimeout;

        // Función para mostrar con fadeIn
        function fadeIn(element) {
            promo.style.display = 'block';
            // Pequeño delay para que la transición funcione
            setTimeout(() => {
                element.classList.remove('fade-out');
                element.classList.add('fade-in');
            }, 10);
        }

        function fadeOut(element) {
            element.classList.remove('fade-in');
            element.classList.add('fade-out');

            element.addEventListener('transitionend', function handler() {
                promo.style.display = 'none';
                element.removeEventListener('transitionend', handler);
            }, { once: true });
        }

        function startCycle() {
            fadeIn(inner);

            hideTimeout = setTimeout(() => {
                fadeOut(inner);
            }, 10000);
        }

        startCycle();

        // Repetir cada 30 segundos (10s visible + 20s oculto)
        cycleInterval = setInterval(startCycle, 30000);

        if (btnClose) {
            btnClose.addEventListener('click', () => {
                clearTimeout(hideTimeout);
                clearInterval(cycleInterval);
                fadeOut(inner);
            });
        }
    }

});


/*
const loading = document.getElementById('loading');
loading.style.opacity = '0';
loading.style.transition = 'opacity 0.4s ease';

// Ocultar completamente después de la animación
setTimeout(() => {
    loading.style.display = 'none';
}, 400); // 400ms = duración del fade
*/
